import { EXPRESS_API } from 'configs/api/expressApi';
import { useMutation, useQueryClient } from 'react-query';
import { quickVideoKeys } from './quickVideoKeys';
import { useToastError } from 'lib/hooks';
import { successToast } from 'lib/components/toasts/success';

const deleteQuickVideo = async (quickVideoId: number) => {
  return (await EXPRESS_API.delete(`quick-videos/${quickVideoId}`)).data;
};

interface IDeleteQuickVideoParams {
  closeModalHandler?: () => void;
}

export const useDeleteQuickVideoMutation = ({
  closeModalHandler,
}: IDeleteQuickVideoParams) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  return useMutation((quickVideoId: number) => deleteQuickVideo(quickVideoId), {
    onSuccess: () => {
      successToast({ title: 'Quick Video successfully deleted.' });
      queryClient.invalidateQueries(quickVideoKeys.all());
      if (closeModalHandler) {
        closeModalHandler();
      }
    },
    onError: err => {
      showError(err);
    },
  });
};
